import Base from '@domain/composition/Base';
import { PRODUCT_SUBCATEGORIES, composingPendantSubFamilyCodes } from '../data/Constants'

export const instanceofType = <T extends Base = Base>(element: T, typeName: string) => {
    let currentClass = element.constructor as typeof Base;

    while (currentClass) {
        if (currentClass.className === typeName) {
            return true;
        }
        const superClass = Object.getPrototypeOf(currentClass.prototype);
        if (!superClass) break;
        currentClass = superClass.constructor as typeof Base;
    }
    return false;
}



export const isModelComposingPendants = (model: string) => {
    const cpFamilies = Object.keys(composingPendantSubFamilyCodes)
    const result = cpFamilies.find(family => {
        const cpModels = composingPendantSubFamilyCodes[family]
        return cpModels.find(cpModel => cpModel == model)
    })
    return Boolean(result)
}

const allowedTypes = ['days', 'weeks', 'months'] as const
type AllowedUnits = typeof allowedTypes[number]
export const convertTimeTo = (date: number, unit: AllowedUnits): number => {

    if (typeof date !== 'number' || !allowedTypes.includes(unit)) {
        throw new Error('Invalid input');
    }

    // Milisegundos en una semana (7 días * 24 horas * 60 minutos * 60 segundos * 1000 milisegundos)
    const millisecondsInADay = 24 * 60 * 60 * 1000;
    const millisecondsInAWeek = 7 * millisecondsInADay;
    const millisecondsInAMonth = 30 * millisecondsInADay; // Aproximadamente 30 días por mes

    switch (unit) {
        case 'days':
            return date / millisecondsInADay;
        case 'weeks':
            return date / millisecondsInAWeek;
        case 'months':
            return date / millisecondsInAMonth;
        default:
            return NaN;
    }
}

export function protectFromUndefinedOrNaN(value, fallback) {
    if (!value || isNaN(value)) {
        return fallback
    } else {
        return value
    }
}


export const isComposingPendantsCategory = (category) => category?.subcategory?.id === PRODUCT_SUBCATEGORIES.COMPOSING_PENDANTS